import { getData } from '../utils/data.js';
export const NotificationType = {
    Trapping: 'trapping',
    Setup: 'setup',
    Dormant: 'dormant',
    ReceiveInvitation: 'receiveInvitation',
    Raw: 'raw',
};
export const NotificationConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(n) {
        return n;
    },
};
export const getNotificationTitle = (input) => {
    switch (input.type) {
        case 'dormant':
            return {
                title: '異常検知 (デバイス)',
                summary: `${input.clientDeviceIds[0]}に異常の可能性があります`,
            };
        case 'setup':
            return {
                title: '電源on (デバイス)',
                summary: `${input.clientDeviceIds[0]}の電源がonになりました`,
            };
        case 'trapping':
            return {
                title: '罠作動 (デバイス)',
                summary: `${input.clientDeviceIds[0]}が作動しました`,
            };
        case 'receiveInvitation':
            return {
                title: '招待 (グループ)',
                summary: `${input.sentBy?.userName}さんから${input.sentBy?.clientName}への招待が来ました`,
            };
        case 'raw':
            return {
                title: 'メッセージ',
                summary: input.rawSubject,
            };
    }
};
//# sourceMappingURL=notification.js.map